export default __webpack_public_path__ + "static/media/units-left-6.0ae51cc1.svg";